<template>
  <v-card outlined class="ma-2">
    <v-form
      ref="refInterimForm"
      v-model="valid"
      lazy-validation
      autocomplete="off"
    >
      <v-list-item>
        <v-list-item-content class="pb-0">
          <v-text-field
            v-model="name"
            class="mr-2"
            dense
            :label="`${$t('documents.name')}`"
            required
            style="width: 100px"
            @keydown="filterKey"
            :rules="[rules.required]"
          ></v-text-field>
        </v-list-item-content>

        <v-list-item-content class="pb-0">
          <v-text-field
            v-model="title"
            dense
            :label="`${$t('title')}`"
            style="width: 100px"
            @keydown="filterKey"
          ></v-text-field>
        </v-list-item-content>

        <!-- Save and Cancel Icons -->
        <v-list-item-action>
          <v-row no-gutters>
            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    @click="onAddClick"
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon size="20">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("presentor.addPresentor") }}</span>
              </v-tooltip>
            </v-col>
            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="close" v-bind="attrs" v-on="on">
                    <v-icon size="20">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("btnClose") }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-list-item-action>
      </v-list-item>
    </v-form>
  </v-card>
</template>

<script>
import { createUUID } from "../../utils/util";

export default {
  name: "AddInterimPresentor",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
      name: "",
      title: "",
      rules: {
        required: (value) =>
          !!(value ? value.trim() : "") || this.$t("presentor.nameIsRequired"),
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
  },
  methods: {
    onAddClick,
    close,
    filterKey,
  },
};

function onAddClick() {
  if (this.$refs.refInterimForm.validate()) {
    this.valid = true;
    const obj = {
      id: createUUID(),
      name: this.name,
      title: this.title,
    };
    this.$eventHub.$emit("onAddInterimPresentor", obj);
    this.close();
    this.name = "";
    this.title = "";
    this.$emit("onAdd");
  }
}

function filterKey(e) {
  const key = e.key;
  const specialChar = [
    "!",
    "@",
    "#",
    "$",
    "%",
    "^",
    "&",
    "*",
    "(",
    ")",
    "_",
    "=",
    "+",
    ",",
    "<",
    "?",
    "/",
    ">",
    ":",
    ";",
    '"',
  ];
  if (specialChar.includes(key)) return e.preventDefault();
}

function close() {
  //   this.$emit("input", false);
  this.$emit("onAdd");
}
</script>

<style>
</style>